import { render, staticRenderFns } from "./ManageOurLife.vue?vue&type=template&id=09dc20a6&scoped=true&"
import script from "./ManageOurLife.vue?vue&type=script&lang=js&"
export * from "./ManageOurLife.vue?vue&type=script&lang=js&"
import style0 from "./ManageOurLife.vue?vue&type=style&index=0&id=09dc20a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc20a6",
  null
  
)

export default component.exports